// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
export function toKeyValueString(obj: any): string {
  return Object.keys(obj).reduce((keyValueString, key, curInd) => {
    let keyValPair = `${key}=${obj[key]}`;
    if (curInd !== 0) {
      keyValPair = ',' + keyValPair;
    }
    return keyValueString + keyValPair;
  }, '');
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
export function getEnumValues(e: any): string[] {
  return Object.keys(e).map((k) => e[k]);
}

export const prefixObj = (obj: object, prefix: string) => {
  if (!prefix) return obj;

  return Object.entries(obj).reduce((acc, [curKey, curVal]) => ({ ...acc, [`${prefix}${curKey}`]: curVal }), {});
};

export const sanitizePrefixedObj = (obj: object, prefix: string) => {
  if (!prefix) return obj;

  return Object.entries(obj).reduce((acc, [curKey, curVal]) => ({ ...acc, [curKey.replace(prefix, '')]: curVal }), {});
};
